import React from 'react';
import { withFormsy } from 'formsy-react';
import './validators';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import ThemeProvider from '@material-ui/styles/ThemeProvider';
import styled from 'styled-components';
import { createMuiTheme } from '@material-ui/core/styles';
import { navy, redBrick, darkTaupe, sansSerif } from '../../const';

const theme = createMuiTheme({
  palette: {
    primary: { main: navy },
    error: { main: redBrick }
  },
  override: {}
});

const StyledSelect = styled(Select)`
  label.focused {
    color: ${navy};
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${darkTaupe};
  }

  .MuiSelect-select {
    background-color: white;
    padding: 16px;
    font-family: ${sansSerif}, sans-serif;
    color: ${navy};
    &:focus {
      background-color: white;
    }
  }
`;

function FormsySelectMui(props) {
  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);
  React.useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  const handleChange = e => {
    if ('mask' in props) {
      e.target.value = props.mask(e.target.value);
    }

    if ('onChange' in props) props.onChange(e);
    if ('setValue' in props)
      props.setValue(
        e.currentTarget[props.type === 'checkbox' ? 'checked' : 'value']
      );
  };

  const handleBlur = e => {
    if ('onBlur' in props) props.onBlur(e);
  };

  const handleFocus = e => {
    if ('onFocus' in props) props.onFocus(e);
  };

  const renderSuccessIcon = classes => {
    if (classes.includes('valid'))
      return (
        <div className="input-icon-wrap">
          <svg
            className="input-icon input-icon__success"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 15 10"
          >
            <title>Input Success</title>
            <path className="stroke booger" d="M1.2,5.1l4.2,4.6l8.2-9.2" />
          </svg>
        </div>
      );
  };

  //todo: performance enhancements
  const {
    type,
    value,
    name,
    showValid,
    isValid,
    isPristine,
    placeholder,
    errorMessages,
    showError,
    autoComplete,
    className = 'input__group',
    options
  } = props;
  const inputProps = {
    type,
    name,
    value,
    autoComplete,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus
  };

  const errors = showError && !isValid ? errorMessages : '';

  let classes = className;
  classes += isValid || isPristine ? '' : ' error';
  classes += showValid === true && isValid ? ' valid' : '';

  return (
    <div className={classes}>
      <div className="select-mui">
        <ThemeProvider theme={theme}>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <InputLabel ref={inputLabel} id={`${name}-label`}>
              {placeholder}
            </InputLabel>
            <StyledSelect
              id={name}
              labelId={`${name}-label`}
              className="select-mui"
              labelWidth={labelWidth}
              variant="outlined"
              {...inputProps}
              error={showError && !isValid}
            >
              {/* How to get props.children to work with styled version of Select component */}
              {options.map(option => (
                <MenuItem value={option.value} key={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </StyledSelect>
          </FormControl>
        </ThemeProvider>
        {renderSuccessIcon(classes)}
      </div>

      <span className="input__error">{errors}</span>
    </div>
  );
}

export default withFormsy(FormsySelectMui);



// WEBPACK FOOTER //
// ./src/components/form/FormsySelectMui.js